import { getLastApiRequestId, rememberRequestIdFromResponse } from "./request-id";

/**
 * Browser fetch wrapper: forwards the last API `X-Request-Id` and stores the ID from each response for correlation.
 */
export function fetchApi(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  const headers = new Headers(init?.headers);
  const prev = getLastApiRequestId();
  if (prev) {
    headers.set("X-Request-Id", prev);
  }

  return fetch(input, { ...init, headers, credentials: "include" }).then((res) => {
    rememberRequestIdFromResponse(res);
    return res;
  });
}
